module.exports = "/_next/static/images/Hero@2x-7ffa016f7979a7e5afeee44f72fa5afd.png";